const removeDuplicates = (arr) => {
    const unique_array = arr.filter((elem, index, self) => {
        return index === self.indexOf(elem);
    })
    return unique_array;
}

export default removeDuplicates;